import { OnInit } from '@angular/core';
import { ABTest } from '@freelancer/abtest';
import { Auth } from '@freelancer/auth';
import { Datastore, } from '@freelancer/datastore';
import { Feature, FeatureFlagsService } from '@freelancer/feature-flags';
import { ButtonColor } from '@freelancer/ui/button';
import * as Rx from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
var NavigationSecondaryProjectsComponent = /** @class */ (function () {
    function NavigationSecondaryProjectsComponent(locale, auth, abtest, datastore, featureFlagService) {
        this.locale = locale;
        this.auth = auth;
        this.abtest = abtest;
        this.datastore = datastore;
        this.featureFlagService = featureFlagService;
        this.Feature = Feature;
        this.ButtonColor = ButtonColor;
    }
    NavigationSecondaryProjectsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.isGiveGetEligible$ = this.datastore
            .document('referralInvitationCheck', this.auth.getUserId())
            .valueChanges()
            .pipe(map(function (result) { return result.isEligible; }));
        this.userCountry$ = this.datastore
            .document('usersSelf', this.auth.getUserId())
            .valueChanges()
            .pipe(map(function (result) {
            return result.address !== undefined && result.address.country !== undefined
                ? result.address.country
                : '';
        }));
        this.showGiveButton$ = Rx.combineLatest([
            this.isGiveGetEligible$,
            this.userCountry$,
            this.featureFlagService.getFlag(Feature.GIVE_GET),
        ]).pipe(switchMap(function (_a) {
            var isGiveGetEligible = _a[0], userCountry = _a[1], featureFlag = _a[2];
            // Show give button on navbar when the whitelist cookie is set.
            if (_this.abtest.isWhitelistUser()) {
                return Rx.of(true);
            }
            return Rx.of(
            // User who is in the US.
            userCountry === 'United States' &&
                // English user.
                _this.locale.startsWith('en') &&
                // Have give get feature flag enabled.
                featureFlag &&
                // Eligible to the give get program.
                isGiveGetEligible);
        }));
    };
    return NavigationSecondaryProjectsComponent;
}());
export { NavigationSecondaryProjectsComponent };
